"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useHorizonDataTable: ()=>useHorizonDataTable
});
const react_table_namespaceObject = require("@tanstack/react-table");
const external_utils_cjs_namespaceObject = require("./utils.cjs");
const customFilterFns = {
    fuzzy: external_utils_cjs_namespaceObject.fuzzyFilter
};
const useHorizonDataTable = ({ columnResizeMode = 'onChange', columns, enableColumnFilters = false, enableGlobalFilter = false, enableMultiRowSelection = false, enableMultiSort = false, enableSorting = false, filterFns, globalFilterFn = 'auto', isMultiSortEvent = ()=>true, rowsPerPageOptions = [
    10,
    25,
    50,
    100
], ...options })=>(0, react_table_namespaceObject.useReactTable)({
        columns: columns.map((column)=>({
                enableColumnFilter: false,
                ...column.enableColumnFilter && {
                    filterFn: 'arrIncludesSome'
                },
                ...column
            })),
        columnResizeMode,
        enableColumnFilters,
        enableGlobalFilter,
        enableMultiRowSelection,
        enableMultiSort,
        enableSorting,
        filterFns: {
            ...filterFns,
            ...customFilterFns
        },
        globalFilterFn: globalFilterFn,
        meta: {
            ...options.meta,
            rowsPerPageOptions
        },
        isMultiSortEvent,
        ...options
    });
exports.useHorizonDataTable = __webpack_exports__.useHorizonDataTable;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "useHorizonDataTable"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
